
export const routes = (prefix = `master-data`) => [
    {
        path: `/${prefix}/accounts/price-schemes`,
        name: `${prefix}.accounts.price-schemes.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.accounts.price-schemes.index`,
                PageDescription: "Accounts master data: Price schemes",
            },
        },
    },
];
